export enum AccessRightLevelEnum {
  None = -1,
  ViewAccess = 0,
  DeveloperAccess = 0.5,
  EditAccess = 1,
  AdminAccess = 2,
}
